var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5940_16366)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5940_16366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.61261 8.79781L9.1441 12.6476C9.4295 12.984 9.38814 13.4881 9.05172 13.7735C8.7153 14.0589 8.21121 14.0175 7.92581 13.6811L3.22959 8.56166C3.16206 8.49381 3.10734 8.41432 3.06806 8.32702C3.01921 8.21851 2.99528 8.10043 2.99801 7.98146L2.99803 7.98072C3.00074 7.86201 3.02983 7.7454 3.08316 7.63931C3.08835 7.62904 3.09376 7.61888 3.09938 7.60884C3.13193 7.5506 3.17171 7.49671 3.21776 7.44845L8.03885 2.24701C8.33875 1.92344 8.84417 1.90427 9.16773 2.20416C9.49128 2.50406 9.51046 3.00949 9.21057 3.33304L5.62621 7.20018H14.1863C14.6275 7.20018 14.9851 7.55783 14.9851 7.999C14.9851 8.44018 14.6275 8.79782 14.1863 8.79782H5.61261V8.79781Z",
    fill: "url(#paint0_linear_5940_16366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61261 8.79781L9.1441 12.6476C9.4295 12.984 9.38814 13.4881 9.05172 13.7735C8.7153 14.0589 8.21121 14.0175 7.92581 13.6811L3.22959 8.56166C3.16206 8.49381 3.10734 8.41432 3.06806 8.32702C3.01921 8.21851 2.99528 8.10043 2.99801 7.98146L2.99803 7.98072C3.00074 7.86201 3.02983 7.7454 3.08316 7.63931C3.08835 7.62904 3.09376 7.61888 3.09938 7.60884C3.13193 7.5506 3.17171 7.49671 3.21776 7.44845L8.03885 2.24701C8.33875 1.92344 8.84417 1.90427 9.16773 2.20416C9.49128 2.50406 9.51046 3.00949 9.21057 3.33304L5.62621 7.20018H14.1863C14.6275 7.20018 14.9851 7.55783 14.9851 7.999C14.9851 8.44018 14.6275 8.79782 14.1863 8.79782H5.61261V8.79781Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61261 8.79781L9.1441 12.6476C9.4295 12.984 9.38814 13.4881 9.05172 13.7735C8.7153 14.0589 8.21121 14.0175 7.92581 13.6811L3.22959 8.56166C3.16206 8.49381 3.10734 8.41432 3.06806 8.32702C3.01921 8.21851 2.99528 8.10043 2.99801 7.98146L2.99803 7.98072C3.00074 7.86201 3.02983 7.7454 3.08316 7.63931C3.08835 7.62904 3.09376 7.61888 3.09938 7.60884C3.13193 7.5506 3.17171 7.49671 3.21776 7.44845L8.03885 2.24701C8.33875 1.92344 8.84417 1.90427 9.16773 2.20416C9.49128 2.50406 9.51046 3.00949 9.21057 3.33304L5.62621 7.20018H14.1863C14.6275 7.20018 14.9851 7.55783 14.9851 7.999C14.9851 8.44018 14.6275 8.79782 14.1863 8.79782H5.61261V8.79781Z",
    stroke: "url(#paint1_linear_5940_16366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61261 8.79781L9.1441 12.6476C9.4295 12.984 9.38814 13.4881 9.05172 13.7735C8.7153 14.0589 8.21121 14.0175 7.92581 13.6811L3.22959 8.56166C3.16206 8.49381 3.10734 8.41432 3.06806 8.32702C3.01921 8.21851 2.99528 8.10043 2.99801 7.98146L2.99803 7.98072C3.00074 7.86201 3.02983 7.7454 3.08316 7.63931C3.08835 7.62904 3.09376 7.61888 3.09938 7.60884C3.13193 7.5506 3.17171 7.49671 3.21776 7.44845L8.03885 2.24701C8.33875 1.92344 8.84417 1.90427 9.16773 2.20416C9.49128 2.50406 9.51046 3.00949 9.21057 3.33304L5.62621 7.20018H14.1863C14.6275 7.20018 14.9851 7.55783 14.9851 7.999C14.9851 8.44018 14.6275 8.79782 14.1863 8.79782H5.61261V8.79781Z",
    stroke: "#4435F5",
    strokeOpacity: 0.3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5940_16366",
    x: 1.4978,
    y: 1.49121,
    width: 14.9873,
    height: 14.9717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5940_16366"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5940_16366",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5940_16366",
    x1: 2.9978,
    y1: 7.97719,
    x2: 14.9851,
    y2: 7.97719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C51D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6EDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5940_16366",
    x1: 2.9978,
    y1: 7.97719,
    x2: 14.9851,
    y2: 7.97719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C51D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6EDFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5940_16366"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.600098,
    y: 0.799805,
    width: 16.2,
    height: 15,
    rx: 7.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtBack);
export default __webpack_public_path__ + "static/media/ATBack.3955cb59df690e9b75d6cf3223fc9119.svg";
export { ForwardRef as ReactComponent };